import Store from 'store/store';
import cached from 'utils/cached';
import { api } from 'utils/bolt/api';
import { accessNested } from 'utils/utils';

const getAppRegions = cached(async () => {
	const store = Store.get();
	const slug = accessNested(store, 'appData.meta.title.slug');
	try {
		const result = await api('/app/regions', { slug });
		return result.response;
	} catch (e) {
		console.error(e);
		return null;
	}
});

export default getAppRegions;
